// extracted by mini-css-extract-plugin
export default {"combo":"comboStyle_combo__V0A9c"};